import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Tilauksen tiedot',
  sections: {
    driver_info: 'Kuljettajan tiedot',
    order_info: 'Tilauksen tiedot',
    price_info: 'Hintatiedot',
    adjustments: 'Muutokset',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Nouto',
    [ORDER_METHODS.delivery]: 'Toimitus',
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Huonepalvelu',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Pöytäpalvelu',
  },
  room_service_location_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: {
      details_label: 'Huoneen numero',
    },
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: {
      details_label: 'Pöydän numero',
    },
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: 'Tämä tilaus odottaa hyväksyntää',
    [FULFILLMENT_STATUSES.reviewed]: 'Tämä tilaus odottaa hyväksyntää',
    [FULFILLMENT_STATUSES.accepted]: 'Tätä tilausta käsitellään parhaillaan',
    [FULFILLMENT_STATUSES.preparing]: 'Tätä tilausta käsitellään parhaillaan',
    [FULFILLMENT_STATUSES.ready]: 'Tämä tilaus on valmis asiakkaan noudettavaksi',
    [FULFILLMENT_STATUSES.on_delivery]: 'Tämä tilaus on toimitettavana asiakkaalle',
    [FULFILLMENT_STATUSES.picked]: 'Tämä tilaus täytettiin onnistuneesti',
    [FULFILLMENT_STATUSES.rejected]: 'Tämä tilaus on hylätty ja hyvitetty',
    default: 'Tämä tilaus täytettiin onnistuneesti',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Asiakkaan pyynnöstä',
    [REFUND_REASONS.Reclamation]: 'Reklamaatio',
    [REFUND_REASONS.CommunicationError]: 'Viestintävirhe',
    [REFUND_REASONS.Other]: 'Muu',
    [REFUND_REASONS.Dispute]: 'Asiakkaan riitautus',
    dispute_win: 'Voitettu asiakasriita',
    null: '',
    undefined: '',
  },
  labels: {
    discount: 'Alennus',
    driver_name: 'Kuljettajan nimi',
    driver_phone_number: 'Kuljettajan puhelin',
    pin_code: 'PIN',
    invoice_payment: 'Maksu laskulla',
    paid_in_cash: 'Käteismaksu',
    customer_paid_online: 'Asiakas maksoi verkossa',
    phone: 'Puh',
    email: 'Sähköposti',
    points_used: 'Tämä tilaus sisältää kanta-asiakkaan lunastaman kanta-asiakaspistepalkinnon',
    delivery: 'Toimitus',
    pickup: 'Nouto',
    original: 'Alkuperäinen',
    delivery_fee: 'Toimitusmaksu',
    tip: 'Tippi',
    service_fee: 'Verkkomaksun käsittely',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'PayPal-maksu',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Prosenttialennus kokonaissummasta käytetty',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Prosenttialennus tuotteista käytetty',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Euromääräinen alennus tuotteista käytetty',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Euromääräinen alennus kokonaissummasta käytetty',
      [OFFER_KIND.BOGO]: 'Osta yksi, saa yksi käytetty',
      [OFFER_KIND.BOGO_HALF_PRICE]: 'Osta yksi, saa toinen puoleen hintaan käytetty',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Ilmainen tuote tuotteista käytetty',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Ilmainen tuote kokonaissummasta käytetty',
      GiftCard: 'Lahjakortti käytetty',
      Reward: 'Kanta-asiakaspisteet käytetty',
      CashbackAccount: 'Kanta-asiakaspisteet käytetty',
      PromoCodeComponent: 'Kampanja käytetty',
      Offer: 'Tarjous käytetty',
    },
    total_discount: 'Kampanja käytetty',
    tax: 'Verot',
    total: 'Yhteensä',
    today: 'Tänään',
  },
  schedule: {
    header: 'Ajoitettu: {{date}}, {{time}}',
    text: 'Muistutamme sinua, kun on aika aloittaa tilauksen valmistaminen',
  },
};
